<script>
    export let answers
    export let next

    import { fade } from 'svelte/transition';
</script>

<style>
    .answers {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        width: 100%;
    }
    .answer {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    button {
        width: 100%
    }

    @media (hover: hover) and (pointer: fine) {
		:global(button:hover) {
        	background-color: #ddd;
        	color: #191919;
    	}
	}

	:global(button:focus, button:active) {
			background-color: #ddd;
        	color: #191919;
			border: 0.1em solid #ddd;
	}

    @media (max-width: 640px) {
        .answers {
            width: 90%;
        }
    }
</style>


<div class="answers" in:fade="{{ duration: 600 }}">
    {#each Object.entries(answers) as [answer, result]}
        <div class="answer">
            <button on:click={() => next(result)}>{answer}</button>
        </div>
    {/each}
</div>